import { defineStore } from "pinia";
import { computed, reactive, toRefs } from "vue";
import { GetStorage, SetStorage } from "@/utils/auth.js";
import config from "@/config/index.js";
import {setThemeColor} from '@/utils/theme.js'
const { theme_config } = config;
export const themeStore = defineStore("theme", () => {
  const state = reactive({
    theme: JSON.parse(GetStorage("theme")) || { ...theme_config },
    visible: false, //主题设置弹窗的显示与隐藏
  });
  const setTheme = () => {
    document.getElementsByTagName("body")[0].setAttribute(
      "style",
      `
    --el-menu-width: ${state.theme.menuWidth};
  `
    );
    setThemeColor(state.theme.color);
  };
  const saveTheme = () => {
    SetStorage("theme", JSON.stringify(state.theme));
  };
  const themeData = computed(() => {
    return state.theme;
  });
  return {
    themeData,
    saveTheme,
	setTheme,
    ...toRefs(state),
  };
});
